/**
 * @class
 * @function ThemeFooter
 */

document.addEventListener("click", function(e) {
  const targetBtn = e.target.closest("#footer .widget--menu .thb-widget-title.collapsible");
  
  if (!targetBtn || window.innerWidth >= 768) return;

  e.preventDefault();
  e.stopPropagation();

  const isCurrentlyOpen = targetBtn.classList.contains("active");

  const allButtons = document.querySelectorAll("#footer .widget--menu .thb-widget-title.collapsible");
  allButtons.forEach(btn => {
    btn.classList.remove("active");
    btn.setAttribute("aria-expanded", "false");
    
    const nextMenu = btn.parentElement.querySelector(".thb-widget-menu");
    if (nextMenu) {
      nextMenu.style.setProperty("display", "none", "important");
    }
  });

  if (!isCurrentlyOpen) {
    targetBtn.classList.add("active");
    targetBtn.setAttribute("aria-expanded", "true");
    
    const targetMenu = targetBtn.parentElement.querySelector(".thb-widget-menu");
    if (targetMenu) {
      targetMenu.style.setProperty("display", "block", "important");
    }
  }
}, true);

window.addEventListener("resize", function() {
  if (window.innerWidth >= 768) {
    const allMenus = document.querySelectorAll("#footer .widget--menu .thb-widget-menu");
    const allButtons = document.querySelectorAll("#footer .widget--menu .thb-widget-title.collapsible");
    
    allMenus.forEach(menu => {
      menu.style.removeProperty("display");
    });
    
    allButtons.forEach(btn => {
      btn.classList.remove("active");
      btn.setAttribute("aria-expanded", "false");
    });
  }
});


document.addEventListener("submit", function(e) {
  const form = e.target.closest(".footer-subscribe-bar .subscribe-form");
  if (!form) return;

  const btn = form.querySelector('button[type="submit"]');
  if (btn) {
    btn.innerHTML = "Submitting..."; 
    btn.style.opacity = "0.7";
    btn.style.cursor = "wait";

    let existingMsg = form.querySelector(".subscription-msg");
    if (existingMsg) existingMsg.remove();

    setTimeout(() => {
      btn.disabled = true;
    }, 50);
  }
});